import { AxiosRequestConfig, AxiosResponse } from 'axios';
import querystring from 'querystring';
import config from 'config';

import { parseAccessToken, parseUserInfo } from 'models/paramountPlus';
import {
  HttpClient,
  QueryOptions,
  ParamountPlusAccessTokenResponse,
  ParamountPlusUserInfoResponse,
} from './api-types';

const BASE_URL = config.api.apiUrl;
const API_KEY = config.api.apiKey;

const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: options && options.data ? 'post' : 'get',
    headers: { 'x-api-key': API_KEY },
  };

  if (options) {
    if (options.params) request.params = options.params;
    if (options.headers) {
      request.headers = {
        ...request.headers,
        ...options.headers,
      };
    }
    if (options.data) {
      request.data = querystring.stringify(
        options.data as querystring.ParsedUrlQueryInput,
      );
      request.headers = {
        ...request.headers,
        'content-type': 'application/x-www-form-urlencoded',
      };
    }
  }
  return httpClient(request);
};

const getOAuthPath = (path: string): string => {
  // https://confluence.mtvi.com/display/SVT/Paramount+plus+proxy+Interface
  // Refer to link on the proxy interface and its unique pathing
  return `vms/paramount/oauth/v1/client/${path}`;
};

const getApiUrl = (path: string): string => {
  return `${BASE_URL}${path}`;
};

export const fetchAccessToken = async (
  httpClient: HttpClient,
  refreshToken: string,
  clientId: string,
  clientSecret: string,
): Promise<ParamountPlusAccessTokenResponse> => {
  const response = await queryApi(
    httpClient,
    getApiUrl(getOAuthPath('cbssports/accessToken.json')),
    {
      data: {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      },
    },
  );

  return parseAccessToken(response.data);
};

export const revokeToken = async (
  httpClient: HttpClient,
  refreshToken: string,
  clientId: string,
  clientSecret: string,
): Promise<boolean> => {
  const response = await queryApi(
    httpClient,
    getApiUrl(getOAuthPath('revokeToken.json')),
    {
      data: {
        client_id: clientId,
        client_secret: clientSecret,
        token: refreshToken,
      },
    },
  );

  return response.data.success;
};

export const fetchUserInfo = async (
  httpClient: HttpClient,
  accessToken: string,
): Promise<ParamountPlusUserInfoResponse> => {
  const response = await queryApi(
    httpClient,
    getApiUrl(getOAuthPath('cbssports/userInfo.json')),
    {
      params: {
        access_token: accessToken,
      },
    },
  );

  return parseUserInfo(response.data);
};
